var classes = {"root":"gVsis"};

export { classes as default };
